import { VFC } from "react";

const lbToBr = (txt: string) => {
  const result = txt
    .split(/(\n|\\n)/g)
    .map((t) => (["\n", "\\n"].includes(t) ? <br /> : t));
  return result;
};

type Props = { text: string };
/**
 * 改行文字\nとエスケープされた改行文字\\nをbrタグに変更する
 * @param param0
 * @returns
 */
const LbToBR: VFC<Props> = ({ text }) => {
  return <>{lbToBr(text)}</>;
};
export default LbToBR;
